"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const util_1 = __importDefault(require("util"));
exports.logger = {
    info: (...args) => {
        console.log(`[INFO]${util_1.default.format(...args)}`);
    },
    warn: (...args) => {
        console.warn(`[WARN]${util_1.default.format(...args)}`);
    },
    error: (...args) => {
        console.error(`[ERROR]${util_1.default.format(...args)}`);
    },
};
